import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  padding: 10px 0px;
  margin: 0px auto;
`;
